import { ReactNode } from 'react';
import classNames from 'classnames';

import Url from 'types/Url';
import Link from '@components/atoms/Link';

import classes from './Tag.module.scss';

type Props = {
  className?: string;
  url?: Url;
  children: ReactNode;
};

const Tag = ({ className, url, children }: Props): JSX.Element =>
  url ? (
    <Link component="span" href={url} className={classNames(classes.wrapper, classes.isLink, className)}>
      {children}
    </Link>
  ) : (
    <span className={classNames(classes.wrapper, className)}>{children}</span>
  );

export default Tag;
